export default {
  /**
   * Obtener la ruta actual del state
   */
  getRoute: state => () => state.route,
  /**
   * Obtener la respuesta mockeada
   */
  getMock: state => () => state.mock,
  /**
   * Obtener la ruta actual del state
   */
  getIsExceeded: state => () => state.isExceeded,
  /**
   * Obtener el origen
   */
  getOrigen: state => () => {
    return state.refe ? state.origen + "-" + state.refe : state.origen;
  },
  /**
   * Obtener el model + datos del paso 1
   */
  getPaso1: state => () => state.paso1,
  /**
   * Obtener el model + datos del paso 2
   */
  getPaso2: state => () => state.paso2,
  /**
   * Obtener el model + datos del paso 3
   */
  getPaso3: state => () => state.paso3,
  /**
   * Obtener el model + datos del paso 3
   */
  getPaso4: state => () => state.paso4
};
